<template>
  <div id="simDetail" class="containerWarp">
    <el-row :gutter="40" style="margin-top: -20px;background:#fff;padding-bottom: 10px;">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="blockTitleP" style="margin-left: -10px;">{{ $t('sim.BasicInfo') }}</p>
        <div class="baseContentWarp">
          <el-form id="batteryPop" ref="battery" :model="baseObj" label-position="right" label-width="150px">
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item label="yhubSn" class="yhubSn">
                <p><el-link type="primary" @click="goToDetailPage">
                  {{ baseObj. yhubSn }}
                </el-link>
                </p>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item label="MCUID">
                <p>{{ baseObj.mcuId }}</p>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('BondOrUpdateDevice.OwnedCompany')">
                <p>{{ baseObj.companyNameZh }}</p>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('allDeviceDetail.BindingTime')">
                <p>{{ baseObj.activeTimeZh }}</p>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('sim.GiveMonth')">
                <p>{{ baseObj.giveMonthZh }}</p>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('sim.Expiration')">
                <p>{{ baseObj.expireTimeZh }}</p>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('sim.CardStatus')">
                <p>{{ baseObj.statuZh }}</p>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('sim.SetMeal')">
                <p>{{ baseObj.tcZh }}</p>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="40" style="margin-top:20px;background:#fff;padding-bottom: 10px;">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="blockTitleP" style="margin-left: -10px;">{{ $t('sim.UsageInfo') }}</p>
        <div class="baseContentWarp">
          <el-form id="batteryPop" ref="battery" :model="baseObj" label-position="right" label-width="150px">
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('sim.PackageFlow')">
                <p>{{ baseObj.tcFlowZh }} M</p>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('sim.realFlow')">
                <p>{{ baseObj.realFlowZh }}</p>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('sim.RemainFlow')">
                <p>{{ baseObj.exceedFlowZh }}</p>
              </el-form-item>
            </el-col> -->
            <el-col v-if="baseObj.exceedFlow<=0" :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('sim.RemainFlow')">
                <p>{{ baseObj.exceedFlowZh }}</p>
              </el-form-item>
            </el-col>
            <el-col v-if="baseObj.exceedFlow>0" :xs="24" :sm="12" :lg="8" class="card-panel-col">
              <el-form-item :label="$t('sim.Overflow')">
                <p>{{ baseObj.exceedFlowZh }}</p>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="40" style="margin-top:20px;background:#fff;padding-bottom: 10px;">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="blockTitleP" style="margin-left: -10px;">{{ $t('sim.lifeCycle') }}</p>
        <div class="baseContentWarp" style="padding-left: 10px;">
          <p v-if="list.length==0" style="text-align: center;">{{ $t('yhubReport.Nodata') }}</p>
          <el-steps direction="vertical" :active="list.length" :space="70" finish-status="process">
            <el-step v-for="(item,index) in list" :key="index" :title="item.remark" :description="item.description" />
          </el-steps>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listSim263TableLog } from '@/api/sim'
import { findDeviceInfo } from '@/api/allDevice'
import { getDateAndHour } from '@/utils/updateTime.js'
import i18n from '@/i18n'
export default {
  name: 'DashboardAdmin',
  data() {
    return {
      baseObj: {
      },
      list: []
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
      this.baseObjInit()
      // this.baseObj = JSON.parse(sessionStorage.getItem('simDetail'))
    }
  },
  created() {
    console.log('this.baseObj--', this.baseObj)
    this.queryList()
    this.baseObjInit()
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        [...document.querySelectorAll('.el-steps .el-step__icon div')].forEach((el, index, arr) => {
          el.innerHTML = arr.length - index
        })
      }, 500)
    })
  },
  methods: {
    baseObjInit() {
      this.baseObj = JSON.parse(sessionStorage.getItem('simDetail'))
      if (!this.baseObj.activeTime) {
        this.baseObj.statuZh = '--'
      } else {
        if (this.baseObj.status == 3) {
          this.baseObj.statuZh = i18n.t('sim.RepairStatus')
        } else if (this.baseObj.status == 4) {
          this.baseObj.statuZh = i18n.t('sim.RepairStatus')
        } else {
          if (this.baseObj.expireTime >= new Date().setHours(0, 0, 0, 0)) {
            this.baseObj.statuZh = i18n.t('sim.effective')
          } else {
            this.baseObj.statuZh = i18n.t('sim.Expired')
          }
        }
      }
    },
    queryList() {
      listSim263TableLog({ sn: this.$route.query.sn }).then(res => {
        if (res.resultCode == 1001) {
          this.list = res.resultModel.reverse()
          this.list.forEach(v => {
            v.description = getDateAndHour(v.updateTime)
            switch (v.status) { // 1首次激活，2.续费，3.送修状态，4.报废，5.重置
              case 1:v.remark = i18n.t('sim.activation'); break
              case 2:v.remark = i18n.t('sim.Renew'); break
              case 3:v.remark = i18n.t('sim.Repair'); break
              case 4:v.remark = i18n.t('sim.scrapped'); break
              case 5:v.remark = i18n.t('sim.Reset'); break
            }
          })
        }
      })
    },
    goToDetailPage() { // 去详情页
      // 设备信息
      findDeviceInfo({ mcuId: this.baseObj.mcuId }).then(res => {
        if (res.resultCode == 1001) {
          if (res.resultModel) {
            var routeData
            if (res.resultModel.deviceType.indexOf('e') > -1) {
              routeData = this.$router.resolve({
                path: '/allDevices/allDeviceLithiumDetail',
                // path: '/sim/simDetail',
                query: {
                  mcuId: this.baseObj.mcuId,
                  deviceType: 'e',
                  sn: res.resultModel.deviceSn,
                  id: res.resultModel.id
                }
              })
              window.open(routeData.href, '_self')
            } else if (res.resultModel.deviceType.indexOf('a') > -1) {
              routeData = this.$router.resolve({
                path: '/allDevices/allDeviceDetail',
                // path: '/sim/simDetail',
                query: {
                  mcuId: this.baseObj.mcuId,
                  deviceType: 'a',
                  sn: res.resultModel.deviceSn,
                  id: res.resultModel.id
                }
              })
              window.open(routeData.href, '_self')
            } else if (res.resultModel.deviceType.indexOf('c') > -1) {
              routeData = this.$router.resolve({
                path: '/allDevices/trionicDetail',
                query: {
                  mcuId: this.baseObj.mcuId,
                  deviceType: res.resultModel.deviceType,
                  sn: res.resultModel.deviceSn,
                  id: res.resultModel.id,
                  deviceTypeT: res.resultModel.deviceName
                }
              })
              window.open(routeData.href, '_self')
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
#simDetail.containerWarp{
  background: transparent;
}
#simDetail{
  .baseContentWarp{
    .el-form-item {
      margin-bottom:0px;
    }
    .yhubSn .el-form-item__content{
      line-height: 34px!important;
    }
  }
}
</style>
